import { CurriculumAdapter, LevelLite, LevelStatus } from './types';
import { levels as musicLevels, getLevelById as musicGetLevelById, getLevelIndex as musicGetLevelIndex, getLevelStatus as musicGetLevelStatus, getShortLevelName as musicGetShortLevelName } from '../../../data/curricula/music/levels';
import { getMissionActivity as musicGetMissionActivity } from '../../../data/curricula/music/activities';

// Important: expose stable references to avoid infinite re-renders in effects
// - Use the original objects from musicLevels and musicGetLevelById

export const musicAdapter: CurriculumAdapter = {
  id: 'music',
  // Use the same array/objects exported by the music curriculum
  levels: musicLevels as unknown as LevelLite[],
  getLevelById: (id: string) => musicGetLevelById(id) as unknown as LevelLite | undefined,
  getLevelIndex: (id: string) => musicGetLevelIndex(id),
  getLevelStatus: (levelId: string, currentLevelId: string, completedIds: string[]): LevelStatus =>
    musicGetLevelStatus(levelId, currentLevelId, completedIds) as LevelStatus,
  getShortLevelName: (title: string) => musicGetShortLevelName(title),
  getMissionActivity: (missionId: string) => musicGetMissionActivity(missionId),
};
